<template>
  <div>
    <!--    <button @click="downloadPDF">Print Download</button>-->

    <!--    <button @click="getPdf()">Click to generate pdf</button>-->

    <button class="btn-export-pdf" @click="exportPdf()">Export pdf</button>

    <!--    <vue-html2pdf-->
    <!--      :show-layout="false"-->
    <!--      :float-layout="true"-->
    <!--      :enable-download="true"-->
    <!--      :preview-modal="true"-->
    <!--      filename="university"-->
    <!--      margin="0"-->
    <!--      :pdf-quality="2"-->
    <!--      :manual-pagination="true"-->
    <!--      pdf-format="a4"-->
    <!--      pdf-orientation="portrait"-->
    <!--      pdf-content-width="100%"-->
    <!--      ref="html2Pdf"-->
    <!--    >-->
    <!--      &lt;!&ndash;      @progress="onProgress($event)"&ndash;&gt;-->
    <!--      &lt;!&ndash;      @hasStartedGeneration="hasStartedGeneration()"&ndash;&gt;-->
    <!--      &lt;!&ndash;      @hasGenerated="hasGenerated($event)"&ndash;&gt;-->
    <!--      <section slot="pdf-content">-->
    <!--        <section class="pdf-item">-->
    <!--          <rating-system-->
    <!--            :university-info="universityInfo"-->
    <!--            :uniSummaryRating="uniSummaryRating"-->
    <!--          ></rating-system>-->
    <!--        </section>-->

    <!--        <section class="pdf-item">-->
    <!--          <greetings></greetings>-->
    <!--        </section>-->

    <!--        &lt;!&ndash;-->
    <!--          After this element below, the page will break and any elements after-->
    <!--          <div class="html2pdf__page-break"/> will go to the next page.-->
    <!--         &ndash;&gt;-->

    <!--        <section class="pdf-item">-->
    <!--          <overall-->
    <!--            :university-info="universityInfo"-->
    <!--            :uniSummaryRating="uniSummaryRating"-->
    <!--          ></overall>-->
    <!--        </section>-->

    <!--        <section class="pdf-item">-->
    <!--          <category-->
    <!--            :universityInfo="universityInfo"-->
    <!--            :uniCategoryRatings="uniCategoryRatings"-->
    <!--          ></category>-->
    <!--        </section>-->

    <!--        <section-->
    <!--          class="pdf-item"-->
    <!--          v-for="(criterionCategoryRating,-->
    <!--          criterionCategoryRatingIndex) in uniCategoryRatings"-->
    <!--          :key="'criterionCategoryRating-' + criterionCategoryRatingIndex"-->
    <!--        >-->
    <!--          <criterion-rating-->
    <!--            :uniCategoryRating="criterionCategoryRating"-->
    <!--            :order-number="criterionCategoryRatingIndex + 1"-->
    <!--            :university-info="universityInfo"-->
    <!--          ></criterion-rating>-->
    <!--        </section>-->

    <!--        <section class="pdf-item">-->
    <!--          <basic-facts-->
    <!--            :university-info="universityInfo"-->
    <!--            :uniCategoryRating="uniCategoryRatings"-->
    <!--          ></basic-facts>-->
    <!--        </section>-->
    <!--      </section>-->
    <!--    </vue-html2pdf>-->

    <div class="row" id="pdfDom">
      <section class="pdf-item">
        <rating-system
          :university-info="universityInfo"
          :uniSummaryRating="uniSummaryRating"
        ></rating-system>
      </section>

      <section class="pdf-item">
        <greetings></greetings>
      </section>

      <!--
      After this element below, the page will break and any elements after
      <div class="html2pdf__page-break"/> will go to the next page.
     -->
      <!--        <div class="html2pdf__page-break" />-->

      <section class="pdf-item">
        <overall
          :university-info="universityInfo"
          :uniSummaryRating="uniSummaryRating"
        ></overall>
      </section>

      <section class="pdf-item">
        <category
          :universityInfo="universityInfo"
          :uniCategoryRatings="uniCategoryRatings"
        ></category>
      </section>

      <template
        v-for="(criterionCategoryRating,
        criterionCategoryRatingIndex) in uniCategoryRatings"
      >
        <section
          class="pdf-item"
          v-if="
            criterionCategoryRating.criteria &&
              criterionCategoryRating.criteria.length <= 7
          "
          :key="'criterionCategoryRating-' + criterionCategoryRatingIndex"
        >
          <criterion-rating
            :uniCategoryRating="criterionCategoryRating"
            :order-number="criterionCategoryRatingIndex + 1"
            :university-info="universityInfo"
          ></criterion-rating>
        </section>

        <template v-else>
          <section
            class="pdf-item"
            :key="'criterionCategoryRating-wh-' + criterionCategoryRatingIndex"
          >
            <criterion-rating-header
              :uniCategoryRating="criterionCategoryRating"
              :order-number="criterionCategoryRatingIndex + 1"
              :university-info="universityInfo"
            ></criterion-rating-header>
          </section>

          <section
            v-if="criterionCategoryRatingIndex + 1 !== 6"
            class="pdf-item pdf-item-wth"
            :key="'criterionCategoryRating-wth-' + criterionCategoryRatingIndex"
          >
            <criterion-rating-without-header
              :uniCategoryRating="criterionCategoryRating"
              :order-number="criterionCategoryRatingIndex + 1"
              :university-info="universityInfo"
            ></criterion-rating-without-header>
          </section>
        </template>
      </template>
      <section class="pdf-item">
        <basic-facts
          :university-info="universityInfo"
          :uniCategoryRating="uniCategoryRatings"
        ></basic-facts>
      </section>

      <section class="pdf-item">
        <about-upm-pdf></about-upm-pdf>
      </section>

      <!--      <section class="pdf-item">-->
      <!--        <chart-basic-facts-->
      <!--          :university-info="universityInfo"-->
      <!--          :uniCategoryRating="uniCategoryRatings"-->
      <!--        ></chart-basic-facts>-->
      <!--      </section>-->
    </div>
  </div>
</template>

<script>
import Greetings from "./Greetings";
import Overall from "./Overall";
import Category from "./Category";
import BasicFacts from "./BasicFacts";
import { UniversityService } from "../../../services/university.service";
import { NationService } from "../../../services/nation.service";
import CriterionRating from "./CriterionRating";
import RatingSystem from "./RatingSystem";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import { mapMutations } from "vuex";
import AboutUpmPdf from "./AboutUpmPdf";
import CriterionRatingWithoutHeader from "./CriterionRatingWithoutHeader";
import CriterionRatingHeader from "./CriterionRatingHeader";

export default {
  name: "ExportPdfIndex",
  components: {
    CriterionRatingHeader,
    CriterionRatingWithoutHeader,
    AboutUpmPdf,
    RatingSystem,
    CriterionRating,
    BasicFacts,
    Category,
    Overall,
    Greetings
  },

  data() {
    return {
      universityInfo: {},
      uniSummaryRating: {},
      uniCategoryRatings: [],
      htmlToPdfOptions: {
        margin: 0,

        filename: `certificate.pdf`,

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true
        },

        jsPDF: {
          unit: "px",
          format: "a4",
          orientation: "portrait"
        }
      }
    };
  },
  created() {
    this.getDetailUniversity();
    this.getUniversitySummaryRating();
    this.getUniversityCategoryRating();
  },

  methods: {
    ...mapMutations({
      hideLoading: "HIDE_LOADING",
      showLoading: "SHOW_LOADING"
    }),
    async exportPdf() {
      this.showLoading();
      setTimeout(async () => {
        let pages = document.getElementsByClassName("pdf-item");
        await this.exportHTMLToPDF(pages)
          .then(() => {})
          .finally(() => {
            this.hideLoading();
          });
      }, 5000);
    },
    async exportHTMLToPDF(pages) {
      console.log("exportHTMLToPDF pages", pages);
      const opt = {
        margin: [0, 0],
        filename: "myfile.pdf",
        pagebreak: { mode: ["css", "legacy"], before: ".page-break-pdf" },
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          dpi: 192,
          scale: 4,
          letterRendering: true,
          useCORS: true
        },
        jsPDF: { unit: "pt", format: "a4", orientation: "portrait" }
      };
      const doc = new jsPDF(opt.jsPDF);
      const pageSize = jsPDF.getPageSize(opt.jsPDF);
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        let contentWidth = (595 * 4) / 3;
        let contentHeight = page.clientHeight;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        // page offset
        let position = 0;
        let leftHeight = contentHeight;
        if (i != 0) {
          doc.addPage();
        }

        // let lastPagePicture = page.querySelector(".last-page-picture");
        // if (lastPagePicture) {
        //   let leftHeightTemp = JSON.parse(JSON.stringify(contentHeight));
        //
        //   if (leftHeightTemp > pageHeight) {
        //     //Nếu height trang cuối có chiều cao < chiều cao ảnh cộng margin 30px của ảnh thì + thêm margin cho đủ con số để ảnh sang trang sau
        //     if (
        //       ((leftHeightTemp / pageHeight) % 1) * pageHeight <
        //       10 + lastPagePicture.clientHeight
        //     ) {
        //       lastPagePicture.style.marginTop =
        //         10 +
        //         lastPagePicture.clientHeight -
        //         ((leftHeightTemp / pageHeight) % 1) * pageHeight +
        //         "px";
        //     }
        //   }
        // }

        // L: Landscape, p: portrait; unit: in: inches, mm mm; canvas size: A3, A4, Leeter, [] (when the content is array, for custom size)
        const pageImage = await html2pdf()
          .from(page)
          .set(opt)
          .outputImg();
        if (leftHeight <= pageHeight) {
          doc.addImage(
            pageImage.src,
            "jpeg",
            opt.margin[0],
            opt.margin[1],
            pageSize.width,
            pageSize.height
          );
        } else {
          while (leftHeight > 0) {
            doc.addImage(pageImage.src, "jpeg", 0, position);

            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              doc.addPage();
            }
          }
        }
      }
      doc.save("university.pdf", { returnPromise: true });
    },
    // downloadPDF() {
    //   this.$refs.html2Pdf.generatePdf();
    // },
    async getDetailUniversity() {
      let uniInfo = await new UniversityService().getById(
        this.$route.params.id
      );

      let nation = this.getNation(uniInfo.country_alpha_two_code);
      // console.log('nation:', nation);
      // console.log("getDetailUniversity",uniInfo.country_alpha_two_code)
      this.universityInfo = { ...uniInfo, nation: nation };
    },
    async getUniversityCategoryRating() {
      const response = await new UniversityService().getRatetingByUniId(
        this.$route.params.id
      );
      if (!response) {
        return;
      }

      response.forEach(category => {
        category.star = category.star || null;
        category.weight = category.weight || 0;
        category.score = category.score || 0;
        category.extra = category.extra || "";
      });
      this.uniCategoryRatings = response;
    },
    getNation(country_alpha_two_code) {
      const nation = new NationService().getNation(country_alpha_two_code);
      if (!nation) {
        return;
      }
      return nation.data.name;
    },
    async getUniversitySummaryRating() {
      const response = await new UniversityService().getUniversityRatingSummaries(
        this.$route.params.id
      );
      if (!response) {
        return;
      }
      this.uniSummaryRating = {
        weight: response.weight || 0,
        score: response.score || 0,
        star: response.star || 0,
        extra: response.extra || ""
      };
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/pdf.scss";
</style>
